import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

/**
 * The link as a QR code (plan 6.3), for the phone across the table: drawn as
 * an SVG in the browser, so nothing leaves the page and it works offline.
 */
export function QrCode({ value, label }: { value: string; label: string }) {
  const [svg, setSvg] = useState('');

  useEffect(() => {
    let alive = true;
    QRCode.toString(value, { type: 'svg', margin: 1, errorCorrectionLevel: 'M' })
      .then((s) => {
        if (alive) setSvg(s);
      })
      .catch(() => {
        if (alive) setSvg('');
      });
    return () => {
      alive = false;
    };
  }, [value]);

  if (!svg) return null;
  return (
    <figure className="qr" aria-label={label} title={value}>
      <div dangerouslySetInnerHTML={{ __html: svg }} />
      <figcaption className="muted small">{value}</figcaption>
    </figure>
  );
}
